import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {NbPopoverDirective} from "@nebular/theme";
import {InternalDocument} from "../internal-documents.component";
import {ClickedOutsideEvent} from "../../../directives/clicked-outside.directive";
import {GMTToLocalDateTime} from "../../../date-functions";
import {EndpointsProvider} from "../../../endpoints/endpoint-provider.service";
import {LocalizedDatePipe} from "../../../pipes/localized-date.pipe";

@Component({
    selector: 'internal-document-entry',
    templateUrl: './internal-document-entry.template.html',
    styleUrls: ['./internal-document-entry.style.scss'],
    standalone: false
})
export class InternalDocumentEntryComponent {

	@Input() file: InternalDocument;
	@Input() correlationId: string;
	@Input() blockInputs: boolean;

	@Output() deleteDocumentRequested: EventEmitter<string> = new EventEmitter<string>();

	@ViewChild(NbPopoverDirective, {static: false}) popover: NbPopoverDirective;

	deleteDocumentClicked: boolean = false;

	constructor(private endpoints: EndpointsProvider, private localizedDatePipe: LocalizedDatePipe) {
	}

	download(fileUuid: string) {
		this.endpoints.documents.downloadInternalDocument(this.correlationId, fileUuid);
	}

	delete() {
		this.deleteDocumentRequested.emit(this.file.fileUuid);
		this.closePopover();
	}

	openPopover() {
		this.popover.show();
		this.deleteDocumentClicked = true;
	}

	closePopover(): void {
		this.popover.hide();
		this.deleteDocumentClicked = false;
	}

	openInNewTab(fileUuid: string): void {
		this.endpoints.documents.downloadInternalDocumentAsText(this.correlationId, fileUuid).subscribe(html => {
			const timestamp$ = this.localizedDatePipe
				.transform(this.adjustTimestamp(new Date(this.file.uploadTimestamp)), 'dateAndTime');

			timestamp$.subscribe(adjustedTimestamp => {
				const changedHtml = this.timestampToLocalDateTime(html, adjustedTimestamp);

				const newWindow = window.open(null, '_blank');
				if (newWindow) {
					newWindow.document.write(changedHtml);
				}
			});
		});
	}


	private timestampToLocalDateTime(html: string, adjustedTimestamp: string) {
		const document = new DOMParser().parseFromString(html, "text/html");
		const dateById = document.getElementById('checklistCreationDate');
		if (dateById) {
			dateById.textContent = adjustedTimestamp;
		} else {
			const dateSpanElement = document.evaluate('//html[1]/body[1]/div[1]/div[1]/span[1]',
				document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;

			dateSpanElement.textContent = adjustedTimestamp;
		}

		return new XMLSerializer().serializeToString(document);
	}

	closePopoverIfClickedOutside(event: ClickedOutsideEvent) {
		if (this.deleteDocumentClicked) { // to prevent hiding popup when clicked show popover button
			this.deleteDocumentClicked = false;
		} else if (event.outside) {
			this.closePopover();
		}
	}

	adjustTimestamp(date: Date): Date {
		return GMTToLocalDateTime(date);
	}

	isDeleted(file: InternalDocument) {
		return file.deletionTimestamp != null;
	}

	getDocumentName(file: InternalDocument): string {
		let lastDotIndex = file.fileName.lastIndexOf('.');
		return file.fileName.slice(0, lastDotIndex);
	}
}
